import * as kutils from '../navkendo';
import { fn, IInfOperation } from '@common/utils';
import UISafe = fn.UISafe;
import { DialogService } from '@services/dialogservice';
import { IKWFConnectionInfo, IKWFServerState } from '@common/rwfsignalrtypes';
import { KWFAdminService } from '../admin/KWFApplication.Admin';
import { NavPageAdminService, IUserCustomizationEntry } from '@common/navdata/navpageadminservice';
import { IObservableArray } from '@common/nav';

export class KWFAdminController {
    static $inject = ["$scope", "NavPageAdminService", "DialogService", "KWFAdminService"];
    constructor($scope: ng.IScope, NavPageAdminService: NavPageAdminService, DialogService: DialogService, private KWFAdmin: KWFAdminService) {
        KWFAdmin.KWFApplication.GetGlobalSettings().then(settings => {
            $scope["curr"] = {
                AppName: "RWF3 '" + (settings.NavUrl || "[?baseNavUrl?]") + "'"
            };
        });

        // Refresh Clients
        var refreshDebounced = fn.throttle(() => KWFAdmin.RefreshClients(), 4000, true, true);
        $scope["Clients"] = KWFAdmin.Clients;

        // DeRegister on scope Destroy
        var myRegisteredConnection: IKWFConnectionInfo,
            onRegister = fn.noop; // util : Handle Scope destroy before Register finished

        UISafe(KWFAdmin.Register().then((connection) => {
            myRegisteredConnection = connection;
            onRegister();
            if (myRegisteredConnection)
                this.KWFAdmin.RefreshClients();
        }));
        $scope.$on("$destroy", () => {
            onRegister = () => myRegisteredConnection && KWFAdmin.DeRegister(myRegisteredConnection);
            onRegister();
        });
        $scope.$on("$destroy", KWFAdmin.KWFApplication.RegisterClientChange((item, Added) => refreshDebounced()));

        $scope["WarningMessage"] = (<IKWFServerState><any>KWFAdmin.KWFApplication.ApplicationState).ShutDownWarning;
        $scope["ShowWarning"] = () => DialogService.WhenConfirm("Warnmeldung für alle Clients aktivieren?").then(() =>
            KWFAdmin.toQ(KWFAdmin.Hub.pushNotification("ShutDownWarning", { Message: $scope["WarningMessage"] })));
        $scope["RemoveWarning"] = () => KWFAdmin.Hub.deleteNotification("ShutDownWarning");
        $scope["Recycle"] = () => DialogService.WhenConfirm("Recycle der Anwendung erzwingen?").then(() => UISafe(KWFAdmin.toQ(KWFAdmin.Hub.recycle()).then(() => DialogService.ShowDialog("Ok"))));
        $scope["GridOptions"] = kutils.UpdateGridOptions(<kendo.ui.EntityGridOptions<IKWFConnectionInfo>>{
            dataSource: kutils.GetGridDataSource(KWFAdmin.Clients),
            columns: [
                { field: "ConnectionID", hidden: true },
                { field: "UserName", title: "Benutzer" },
                { field: "AddressInfo", title: "Herkunft" },
                { field: "ClientAddress", title: "Address- Information", hidden: true },
                { field: "CurrentClientState.CurrentUrl", title: "aktuelle Ansicht" },
                { field: "CurrentClientState.LastRouteChange", title: "aktuelle Ansicht geöffnet", format: "{0:dd.MM.yyyy HH:mm:ss}", hidden: true },
                { field: "CurrentClientState.Version.Version", title: "Version" },
                { field: "CurrentClientState.Version.PatchLevel", title: "PatchLevel" },
                { field: "CurrentClientState.UserAgent", title: "UserAgent" },
                { field: "Created", title: "Verbindung hergestellt", format: "{0:dd.MM.yyyy HH:mm:ss}" },
                { field: "LastRefresh", title: "Letzte Rückmeldung", format: "{0:dd.MM.yyyy HH:mm:ss}" },
            ],
            sortable: true, groupable: true, selectable: "row", columnMenu: true, reorderable: true, filterable: true, pageable: true,
        });

        var actRefresh = $scope["actRefresh"] = <IInfOperation>{
            Enabled: true,
            Execute: () => KWFAdmin.RefreshClients(true)
        };

        var actTriggerClientsRefresh = $scope["actTriggerClientsRefresh"] = <IInfOperation>{
            Enabled: true,
            Execute: () => KWFAdmin.ForceClientsRefresh(true)
        };

        var actShowUserSettingsInfo = $scope["actShowUserSettingsInfo"] = <IInfOperation>{
            Enabled: true,
            //Hidden: "Enabled",
            Execute: () => {
                var instance = $scope["RwfAdminShowUserSettings"] = new RwfAdminShowUserSettings(NavPageAdminService, DialogService);
                instance.ActRefresh.Execute();
            }
        };
    }
}

export class RwfAdminShowUserSettings {
    static $inject = ["NavPageAdminService", "DialogService"];
    constructor(readonly NavPageAdminService: NavPageAdminService, DialogService: DialogService) {
        var userCustomizationFolders = this.UserCustomizations = kutils.AsObservableArray<IUserCustomizationEntry>([]);
        this.GridOptions = kutils.UpdateGridOptions(<kendo.ui.EntityGridOptions<IUserCustomizationEntry>>{
            dataSource: kutils.GetGridDataSource(userCustomizationFolders),
            columns: [
                { field: "ID", title : "Ordnername" },
                { field: "LoginName", title: "Login Name" },
                { field: "DisplayName", title: "Display Name" },
                { field: "Name", hidden: true },
                { field: "LastAccess", title: "Letzter Zugriff", format: "{0:dd.MM.yyyy HH:mm:ss}" },
                { field: "Error", hidden: true }
            ],
            sortable: true, groupable: true, selectable: "row", columnMenu: true, reorderable: true, filterable: true, pageable: true,
        });

        this.ActRefresh = {
            Enabled: <boolean>false,
            Running: <boolean>false,
            Execute: () => {
                this.ActRefresh.Enabled = false;
                this.ActRefresh.Running = true;

                NavPageAdminService.GetAllUserCustomizationInfo().then(data => {
                    data.forEach(item => item.LastAccess = fn.ToDate(item.LastAccess));
                    kutils.ReplaceObservableData(this.UserCustomizations, data, item => item.ID);
                    if (data.length > 0) {
                        ActExportToExcel.Enabled = true;
                    }
                }).then(() => {
                    this.ActRefresh.Enabled = true;
                    this.ActRefresh.Running = false;

                }, err => {
                    this.ActRefresh.Enabled = true;
                    this.ActRefresh.Running = false;
                    DialogService.ShowError(err);
                });
            }
        };

        var ActExportToExcel = this.ActExportToExcel = {
            Enabled: <boolean>false,
            Execute: () => {
                if (!(this.GrdRwfAdminShowUserSettings instanceof kendo.ui.Grid)) {
                    throw new Error('Export nicht möglich: Grid not found!');
                }
                kutils.SaveAsExcel([{
                    Grid: this.GrdRwfAdminShowUserSettings,
                    Name: "RWfUserSettings"
                }], { allPages: true });
            }
        };

    }

    readonly UserCustomizations: IObservableArray<IUserCustomizationEntry>;

    readonly GridOptions: kendo.ui.GridOptions;

    readonly ActRefresh: IInfOperation & { Running: boolean };

    readonly ActExportToExcel: IInfOperation;

    readonly GrdRwfAdminShowUserSettings?: kendo.ui.Grid;
}
